import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private toggleSource = new BehaviorSubject<boolean>(false);
  private toggleVasCreateOrder = new BehaviorSubject<boolean>(false);
  private toggleSidebar = new BehaviorSubject<boolean>(JSON.parse(localStorage.getItem('isCollasepedflag') || 'false'));

  toggleState$ = this.toggleSource.asObservable();
  toggleVasCreateOrder$ = this.toggleVasCreateOrder.asObservable();
  toggleSidebar$ = this.toggleSidebar.asObservable();

  constructor() { 
  }
  toggleClass(value: boolean) {
    this.toggleSource.next(value);
  }
  toggleCreateorderClass(value: boolean){
    this.toggleVasCreateOrder.next(value);
  }
  gettoggleSidebar(value: boolean){
    this.toggleSidebar.next(value);
    localStorage.setItem('isCollasepedflag', JSON.stringify(value));
  }
}
